export const BOTAO_CARD_ASSINATURA_UPGRADE = 'Assine plano anual'

export const DESCRICAO_CARD_ASSINATURA_UPGRADE = 'Assine o plano anual e ganhe um brinde exclusivo!'

export const BOTAO_CARD_ASSINATURA_REATIVACAO = 'Reativar assinatura'

export const DESCRICAO_CARD_ASSINATURA_REATIVACAO = 'Para continuar na TAG, reative a sua assinatura.'

export const BOTAO_CARD_ASSINATURA_RENOVACAO = 'Renovar plano'

export const DESCRICAO_CARD_ASSINATURA_RENOVACAO = 'Seu plano anual está chegando ao fim, não esqueça de renovar e ganhar um brinde exclusivo!'

export const BOTAO_CARD_PRESENTEADO = 'Associe-se'

export const DESCRICAO_CARD_APP_DESKTOP = 'No aplicativo você pode avaliar os livros que recebe e conversar com quem ama leitura como você. Para baixar o app em seu celular, basta procurar por TAG Livros na loja de seu dispositivo.'

export const DESCRICAO_CARD_APP_MOBILE = 'No aplicativo você pode avaliar os livros que recebe e conversar com quem ama leitura como você. Para baixar o app em seu celular, basta clicar no botão da sua loja abaixo.'

export const TITULO_CARD_APP = 'Conheça nosso Aplicativo'

export const textoCardPresenteado = tituloModalidade => {
  if ( tituloModalidade ) {
    const textos = {
      'descricao': `Gostou do presente? Continue assinando a ${tituloModalidade} e receba os livros preferidos de grandes nomes da literatura indicados exclusivamente para associados!`,
      'titulo': `Permaneça na ${tituloModalidade}`
    }

    return textos
  }

  return null
}

export const descricaoCardPresenteado = tituloModalidade => {
  if ( tituloModalidade ) {
    return `Permaneça na ${tituloModalidade}`
  }

  return null
}

export const TEXTOS_ONBOARDING = {
  'subtitulo': 'Agora que você faz parte da maior comunidade literária do Brasil, conheça mais sobre a sua jornada no clube.',
  'titulo': 'Desejamos as boas-vindas à TAG!',
}

export const URL_VIDEO_ONBOARDING = 'https://www.youtube.com/watch?v=N-JiRY0ZaSY'

export const TRILHAS_VOLTA_AO_MUNDO = 'https://trilhaclassicos.taglivros.com/?utm_source=ada&utm_medium=banner&utm_campaign=lancamento-trilha-classicos'
